/** Lime nav back control — PROFILE / XP HISTORY in XP modals. */
export const XP_LIME_BACK_BUTTON_CLASS =
  "inline-flex h-[30px] min-h-[30px] max-h-[30px] shrink-0 items-center justify-center gap-1 rounded-none border-0 bg-[#D2FF00] px-2.5 text-center font-anton text-[12px] font-normal uppercase leading-[12px] tracking-normal text-black hover:brightness-95 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-black/30 [leading-trim:none]";

export const XP_BACK_ARROW_SRC = "/assets/arrow-left.svg";

export const XP_BACK_ARROW_CLASS = "h-[20px] w-[20px] shrink-0 object-contain";
